module.exports = __webpack_public_path__ + "img/1.c07cf60b.png";